// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

/**
 * Output format
 * @class VoiceProfileType
 */
export enum VoiceProfileType {

    /**
     * Text independent speaker identification
     * @member VoiceProfileType.TextIndependentIdentification
     */
    TextIndependentIdentification,

    /**
     * Text dependent speaker verification
     * @member VoiceProfileType.TextDependentVerification
     */
    TextDependentVerification,

    /**
     * Text independent speaker verification
     * @member VoiceProfileType.TextIndependentVerification
     */
    TextIndependentVerification,
}
